import "./Portfolio.module.css";
import Header from "@/reusable_sections/Header";
import TheWorkroom from "./sections/TheWorkroom";
import OurProcess from "./sections/OurProcess";
import Timeline from "./sections/Timeline";
import Footer from "@/reusable_sections/Footer";
export default function PortfolioPage() {
  return <div>
      <Header />
      <TheWorkroom />
      <OurProcess />
      <Timeline />
      <Footer />
    </div>;
}